import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
  copyright: {
    fontSize: '13px',
    color: '#999',
  },
})
